@if (alertConcluido === true) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/success.png" width="82px" alt="Sucesso">
      <p class="titulo-alert mt-4 mb-2"> {{ alertConcluidoTitulo }} </p>
      <p class="mensagem-alert mb-15 mx-2"> {{ alertConcluidoMensagem }} </p>
      <div class="footer-alert">
        <button class="botao" (click)="fecharAlertConcluido()">OK</button>
      </div>
    </div>
  </div>
}
